import { Canvas, useFrame } from "@react-three/fiber";
import { Points, PointMaterial } from "@react-three/drei";
import { useRef, Suspense, useMemo } from "react";
import { Points as ThreePoints } from "three";

function Stars({
  count = 12000,
  speed = 0.002,
  size = 0.01,
}: {
  count?: number;
  speed?: number;
  size?: number;
}) {
  const ref = useRef<ThreePoints>(null!);

  const positions = useMemo(() => {
    const arr = new Float32Array(count * 3);

    for (let i = 0; i < count; i++) {
      const i3 = i * 3;
      arr[i3] = (Math.random() - 0.5) * 20;
      arr[i3 + 1] = (Math.random() - 0.5) * 12;
      arr[i3 + 2] = -Math.random() * 2;
    }

    return arr;
  }, [count]);

  useFrame((_, delta) => {
    if (!ref.current) return;
    ref.current.rotation.z += delta * speed;
  });

  return (
    <Points ref={ref} positions={positions} stride={3} frustumCulled={false}>
      <PointMaterial
        transparent
        color="#ffffff"
        size={size}
        sizeAttenuation
        depthWrite={false}
      />
    </Points>
  );
}

export default function StarBackground() {
  return (
    <div className="absolute inset-0 z-0 pointer-events-none">
      <Canvas
        className="w-full h-full"
        camera={{ position: [0, 0, 5] }}
        gl={{ antialias: true, alpha: true }}
        dpr={[1, 2]}
      >
        <Suspense fallback={null}>
          <Stars count={3500} speed={0.0006} size={0.006} />
          <Stars count={1200} speed={0.0012} size={0.012} />
          <Stars count={30} speed={0.0002} size={0.03} />
        </Suspense>
      </Canvas>
    </div>
  );
}
